import React from "react";
import PropTypes from "prop-types";
import i18n from "i18next";
import { LuLayers } from "react-icons/lu";
import AppModal from "../common/modal/AppModal";

// Confirmation prompt shown when the user ticks "Narrate all scenes" next to the
// Save button and then hits Save: a single "are you sure?" gate before the batch
// narrate-all-scenes API runs. Replaces the older two-choice scope modal — the
// scope decision now lives in the footer checkbox, this only confirms it.
const NarrateAllConfirmModal = ({ show, onClose, onConfirm, sceneCount, busy }) => {
  const noop = () => {};

  return (
    <AppModal
      show={show}
      onClose={busy ? noop : onClose}
      size="md"
      maxWidth={460}
      centered
      closeButton={!busy}
      showSceneToggle={false}
      backdrop="static"
      className="narrate-scope-modal"
      title={i18n.t("NarrateScope.ConfirmTitle") || "Tüm sahneleri seslendir"}
      footer={
        <div className="app-modal__footer">
          <button
            type="button"
            className="app-modal__btn app-modal__btn--ghost"
            onClick={busy ? noop : onClose}
            disabled={busy}
          >
            {i18n.t("Cancel") || "Vazgeç"}
          </button>
          <button
            type="button"
            className="app-modal__btn app-modal__btn--primary"
            onClick={busy ? noop : onConfirm}
            disabled={busy}
          >
            {busy ? (
              <span className="add-sound-modal__scope-spinner" aria-hidden="true" />
            ) : (
              <LuLayers size={16} style={{ marginRight: 6 }} />
            )}
            {busy
              ? i18n.t("NarrateScope.Applying") || "Başlatılıyor..."
              : i18n.t("NarrateScope.ConfirmButton") || "Evet, seslendir"}
          </button>
        </div>
      }
    >
      <div className="add-sound-modal add-sound-modal__scope">
        <p className="add-sound-modal__scope-desc">
          {sceneCount
            ? i18n.t("NarrateScope.ConfirmDescCount", { count: sceneCount }) ||
              `Bu ses ${sceneCount} sahneye uygulanacak ve her sahne yeniden seslendirilecek. Devam etmek istediğinize emin misiniz?`
            : i18n.t("NarrateScope.ConfirmDesc") ||
              "Bu ses tüm sahnelere uygulanacak ve her sahne yeniden seslendirilecek. Devam etmek istediğinize emin misiniz?"}
        </p>
      </div>
    </AppModal>
  );
};

NarrateAllConfirmModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  sceneCount: PropTypes.number,
  busy: PropTypes.bool,
};

export default NarrateAllConfirmModal;
